
<div class="p-fluid p-formgrid p-grid">
  <div class="p-field p-col-12 p-md-3">

  </div>
  <div class="p-field p-col-12 p-md-6">
    <div class="card p-p-4 p-m-4" style="border-bottom-width: 5px;border-bottom-color: #007bff;">
      <div class="card p-p-3" style="background-color: #343a40;">
        <div class="card-title text-center">
          <span class="p-text-bold" style="font-family: Roboto,'system-ui',sans-serif;color: white;font-weight: 700;">Email Unsubscribe</span>
        </div>
      </div>
      <div class="p-p-2 text-center">
       <img src="../../../../assets/img/email-logo.png" style="width: 120px;height: auto;">
      </div>
      <div class="card p-mt-1 p-p-0">
        <div class="card-header">
          <div class="card-title">
            <span class="p-text-bold" style="font-family: Roboto,'system-ui',sans-serif;font-size: 15px;margin-left: 27px;">Are you sure you want to unsubscribe from receiving future emails from D-VMS?</span>
          </div>
        </div>
        <div class="card-footer p-p-2 text-center">          
          <button pButton pRipple type="button"  (click)="UnsubscribeEmail()"  [style]="{'width':'125px','height':'30px'}" icon="pi pi-minus-circle" label="Unsubscribe"
          class="p-button-sm p-button-danger"></button>&nbsp;
          <button pButton pRipple type="button"  (click)="onCancel()" [style]="{'width':'100px','height':'30px'}" icon="pi pi-times-circle" label="Cancel"
          class="p-button-sm p-button-info"></button>
        </div>
      </div>    
    </div>    
  </div>
  <div class="p-field p-col-12 p-md-3">
    
  </div>
</div>

<p-dialog [(visible)]="isSuccessMsg" [closable]="true" [baseZIndex]="10000" [draggable]="true" [modal]="true" [resizable]="false">
  <ng-template pTemplate="header">
    <span style="font-size: 20px;font-family: Roboto,'system-ui',sans-serif;font-weight: bold;left: 200px;margin-left: 200px;">Unsubscribe successfull <img src="../../../../assets/img/successgif.gif" style="width: 47px;height: 40px;margin-top: -5px;"/></span>   
  </ng-template>
  <div class="card" style="background-color: aliceblue;">
    <div class="p-p-2 text-center">
      <!-- <label class="p-text-center">You have been successfully unsubscribed from receiving future emails from D-VMS.</label> -->
      <label class="p-text-center">You have been successfully unsubscribed from receiving ALL future emails from D-VMS.</label>
      <!-- <label class="text-center">You may resubscribe anytime from your D-VMS user profile.</label> -->
      <label class="text-center">Please contact rheisaac@devcare.com to resubscribe to any emails.</label>
    </div>
  </div>
  <ng-template pTemplate="footer"></ng-template>
</p-dialog>